export default __webpack_public_path__ + "static/media/brown-connie-kiss.5f69879d.png";